/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Objective } from './objective';
import { IndicatorFutureStatus } from './indicatorFutureStatus';
import { IndicatorMeasurement } from './indicatorMeasurement';
import { Indicator } from './indicator';


/**
 * Objective and related (created via SMART guide)
 */
import { ValidateUtils } from 'app/shared/utils';

export class SmartObjective { 
    objective?: Objective;
    indicator?: Indicator;
    indicatorFutureStatus?: IndicatorFutureStatus;
    indicatorMeasurement?: IndicatorMeasurement;

    constructor(item?: Partial<SmartObjective>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            objective: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.objective : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicator: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicator : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicatorFutureStatus: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorFutureStatus : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            indicatorMeasurement: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorMeasurement : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: SmartObjective.isValid,
        };
    }

    static isValid(obj: SmartObjective): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = SmartObjective.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.objective.isValid(item);
            result = result && validationObject.indicator.isValid(item);
            result = result && validationObject.indicatorFutureStatus.isValid(item);
            result = result && validationObject.indicatorMeasurement.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

